export const referenceListsSelector = state =>
  state.categorisation.referenceLists;
